import { Box } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import PeerReviewApplication from "./pages/peer-review-app";
import EditorialBoardApplication from "./pages/editorial-board-app";
import Articles from "./pages/articles";
import Volumes from "./pages/volumes";
import Purchase from "./pages/purchase";
import SubmitManuscript from "./pages/submit-manuscript";
import Auth from "./pages/auth";
import AuthorDashboard from "./pages/author-dashboard";
import ProtectedRoute from "./utils/protected-route";
import AuthorProfile from "./pages/author-profile";
import PublishingGuidelines from "./pages/publishing-guidelines";
import TermsAndConditions from "./pages/terms-and-conditions";
import AboutUs from "./pages/about-us";
import EditorialBoardHome from "./pages/editorial-board-home"
import PeerReviewersPage from "./pages/peer-reviewers"

function App() {
  return (
    <Box>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>}/>
          <Route path="/volumes" element={<Volumes/>}/>
          <Route path="/articles" element={<Articles/>}/>
          <Route path="/editorial-board" element={<EditorialBoardHome/>}/>
          <Route path="/peer-reviewers" element={<PeerReviewersPage/>}/>
          <Route path="/join-editorial-board" element={<EditorialBoardApplication/>}/>
          <Route path="/join-peer-review" element={<PeerReviewApplication/>}/>
          <Route path="/purchase" element={<Purchase/>}/>
          <Route path="/auth" element={<Auth/>}/>
          <Route path="/submit-manuscript" element={<ProtectedRoute><SubmitManuscript/></ProtectedRoute>}/>
          <Route path="/author-dashboard" element={<ProtectedRoute><AuthorDashboard/></ProtectedRoute>}/>
          <Route path="/author" element={<AuthorProfile/>}/>
          <Route path="/publishing-guidelines" element={<PublishingGuidelines/>}/>
          <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
          <Route path="/about-us" element={<AboutUs/>}/>
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
